module.exports = __webpack_public_path__ + "public/img/en-s.d1c15a85.svg";